module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('Modal', {
    staticClass: "modal-relative",
    attrs: {
      "wide": false,
      "width": "500px"
    },
    on: {
      "close": _vm.closeModal
    }
  }, [(_vm.showDate) ? _c('div', {
    class: {
      'dropdown-wrap-wrapper': true, 'disabled': _vm.loading, 'visible': !_vm.loading
    }
  }, [_c('div', {
    staticClass: "label"
  }, [_vm._v(_vm._s(_vm.$t('general.pick-date')))]), _vm._v(" "), _c('Dropdown', {
    ref: "dateDropdown",
    attrs: {
      "prefixicon": "calendar",
      "prefixicon-validated": "calendar-white",
      "tabindex": "0",
      "options": [],
      "validated": _vm.pickedStartDate,
      "label": '' + _vm.formatDate(_vm.pickedStartDate) + '',
      "bold-label": false
    },
    on: {
      "clicked": _vm.datepickerModal,
      "clicked-suffix": _vm.dateClear
    }
  })], 1) : _vm._e(), _vm._v(" "), (!_vm.loading && !_vm.showDate && _vm.isSeason) ? _c('div', {
    staticClass: "box info",
    staticStyle: {
      "margin-top": "0"
    }
  }, [_c('b', [_c('icon', {
    attrs: {
      "name": "info",
      "scale": 1.4
    }
  }), _vm._v(_vm._s(_vm.$t('skipass.pickup-seasoncard')))], 1), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.$t('skipass.pickup-seasoncard-instructions-1')))]), _vm._v(" "), _c('br'), _vm._v(" "), _c('p', [_c('b', {
    staticStyle: {
      "display": "inline"
    }
  }, [_vm._v(_vm._s(_vm.$t('general.obs')))]), _vm._v(" " + _vm._s(_vm.$t('skipass.pickup-seasoncard-instructions-2')))])]) : _vm._e(), _vm._v(" "), (_vm.showDate) ? _c('div', {
    staticClass: "box info",
    staticStyle: {
      "margin-top": "1em"
    }
  }, [(_vm.hasRefill) ? _c('p', [_vm._v("För laddade liftkort: välj "), _c('strong', [_vm._v("första åkdag")]), _vm._v(".")]) : _vm._e(), _vm._v(" "), (_vm.hasRefill && _vm.hasNonRefill) ? _c('p', [_vm._v(" ")]) : _vm._e(), _vm._v(" "), (_vm.hasNonRefill) ? _c('p', [_vm._v("För nya liftkort: välj den dag du vill "), _c('strong', [_vm._v("hämta")]), _vm._v(" ditt liftkort.")]) : _vm._e()]) : _vm._e(), _vm._v(" "), (_vm.hasNonRefill) ? _c('div', {
    class: 'space center info-wrapper'
  }, [(_vm.FEATURE_IS_NOT_ACTIVE('FeatureUseSkipassMachines')) ? _c('div', [_c('h2', {
    staticClass: "center"
  }, [_vm._v("När ska liftkorten börja användas?"), _c('br')]), _vm._v(" "), _c('Checkbox', {
    attrs: {
      "label-position": "after",
      "label": "",
      "sublabel": _vm.skiPassAccomodationAfterCheckinText,
      "value": 'delivery',
      "valuebinder": _vm.delivery_type,
      "size": 24,
      "below": true
    },
    on: {
      "update:valuebinder": function($event) {
        _vm.delivery_type = $event
      }
    }
  }), _vm._v(" "), _c('Checkbox', {
    attrs: {
      "label-position": "after",
      "label": "",
      "sublabel": _vm.skiPassAccomodationBeforeCheckinText,
      "value": 'pickup',
      "valuebinder": _vm.delivery_type,
      "size": 24,
      "below": true
    },
    on: {
      "update:valuebinder": function($event) {
        _vm.delivery_type = $event
      }
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.FEATURE_IS_ACTIVE('FeatureUseSkipassMachines')) ? _c('div', [_c('h2', {
    staticClass: "center",
    domProps: {
      "innerHTML": _vm._s(_vm.SETTING('SettingSkipassMachineInfo').title + '<br />')
    }
  }), _vm._v(" "), _vm._l((_vm.SETTING('SettingSkipassMachineInfo').paragraphs), function(paragraph, index) {
    return _c('p', {
      key: index,
      domProps: {
        "innerHTML": _vm._s(paragraph)
      }
    })
  })], 2) : _vm._e(), _vm._v(" "), _c('hr')]) : _vm._e(), _vm._v(" "), (_vm.FEATURE_IS_NOT_ACTIVE('FeatureUseSkipassMachines') && _vm.hasNonRefill) ? _c('div', {
    staticClass: "space center info-wrapper"
  }, [_c('h2', {
    staticClass: "center"
  }, [_vm._v("Var vill du hämta liftkorten?"), _c('br')]), _vm._v(" "), _c('Checkbox', {
    attrs: {
      "label-position": "after",
      "label": "",
      "sublabel": "Byn",
      "value": 'by',
      "valuebinder": _vm.site,
      "size": 24,
      "below": true
    },
    on: {
      "update:valuebinder": function($event) {
        _vm.site = $event
      }
    }
  }), _vm._v(" "), _c('Checkbox', {
    attrs: {
      "label-position": "after",
      "label": "",
      "sublabel": "Berget",
      "value": 'berg',
      "valuebinder": _vm.site,
      "size": 24,
      "below": true
    },
    on: {
      "update:valuebinder": function($event) {
        _vm.site = $event
      }
    }
  })], 1) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "center"
  }, [_c('button', {
    class: (!_vm.validated ? 'disabled' : ''),
    on: {
      "click": function($event) {
        return _vm.addToCart()
      }
    }
  }, [_vm._v(_vm._s(_vm.$store.state.isOnSite ? _vm.$t('general.pay-with-card') : _vm.$t('general.add-to-cart')))])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-2c5b6258"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/modals/SkiPassConfirm.vue
// module id = 947
// module chunks = 0